import { EventInput } from "@fullcalendar/common";
import { CalendarEvent, CalendarEventType, CalendarSettings, REST_schema } from "./sharedSchema";

export type CalendarView = "dayGridMonth" | "timeGridWeek" | "timeGridDay" | "listWeek";

// TODO remove after move to context?
export type CalendarState = {
  isLoading: boolean;
  error: boolean;
  events: EventInput[];
  isOpenModal: boolean;
  selectedEventId: null | string;
  selectedRange: null | { start: Date; end: Date };
};

/**
 * Office tasks (a task in a colleague's calendar). Absent = the signed-in user's own calendar,
 * which is every save that is not about an office task.
 */
export type CalendarSaveOptions = {
  /** Whose calendar the task is in now. */
  ownerUserId?: string;
  /** Whose calendar it should be in after this save. */
  assigneeUserId?: string;
};

export type CalendarContextProps = {
  /** The signed-in user's own calendar. */
  events: CalendarEvent[];
  /** Tasks the signed-in user put in colleagues' calendars (the last 90 days); null until loaded. */
  assignedTasks: CalendarEvent[] | null;
  isFetchingEvents: boolean;
  calendarSettings: CalendarSettings;
  initiateLoadEvents: () => void;
  /** A task save with an owner or assignee other than the user goes through the server and reports its own outcome. */
  createOrUpdateEvent: (event: CalendarEvent, options?: CalendarSaveOptions) => Promise<boolean>;
  /** One change to a task the user assigned to a colleague (status, time), through the server. */
  updateOfficeTask: (
    event: CalendarEvent,
    patch: Partial<REST_schema.CalendarTaskFields>
  ) => Promise<boolean>;
  getInitialEventByType: (
    type: CalendarEventType,
    customProps?: Partial<CalendarEvent>
  ) => CalendarEvent;
  updateEventTimeById: (
    eventId: string,
    newStart: Date,
    newEnd: Date,
    newAllDay: boolean
  ) => Promise<boolean>;
  /** With an `ownerUserId` other than the user: cancel a task they assigned, through the server. */
  deleteEvent: (eventId: string, ownerUserId?: string) => Promise<void>;
  updateCalendarSettings: (updatedCalendarSettings: Partial<CalendarSettings>) => Promise<void>;
  showSingleEventEditorModal: (eventId?: string) => void;
  showSingleEventEditorModalByType: (
    type: CalendarEventType,
    customProps?: Partial<CalendarEvent>
  ) => void;
  showSingleEventEditorForDateRangeModal: (start: Date, end: Date) => void;
  // currentState: CalendarState;
  // setCurrentState: (state: CalendarState) => void;
};

export enum CalendarOperationType {
  NEW = "NEW",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
  REMINDER = "REMINDER"
}
